import { Injectable } from '@angular/core';
import { TableInvoiceFields } from '../../../models/invoices';

/** Holds the source STS expense when opening the credit-note issue page from the list. */
@Injectable({ providedIn: 'root' })
export class StsCreditNoteService {
  sourceInvoiceId: string | null = null;
  numero_fattura_originale: string | null = null;
  defaultImporto: number | null = null;

  hasSource(): boolean {
    return this.sourceInvoiceId !== null;
  }

  setSource(invoice: TableInvoiceFields): void {
    this.sourceInvoiceId = invoice.id;
    this.numero_fattura_originale = invoice.progressivo_numero;
    this.defaultImporto = parseFloat(invoice.totale);
  }

  clear(): void {
    this.sourceInvoiceId = null;
    this.numero_fattura_originale = null;
    this.defaultImporto = null;
  }
}
